// extracted by mini-css-extract-plugin
export default {"wrapper":"arMYYN","external":"brMYYN","container":"crMYYN","content":"drMYYN","imageBlock":"erMYYN"};